import { useDocumentHighlight } from "~/stores/useDocumentHighlight";

export const useDocumentHighlightStore = (documentId: string) => {
  const { revision } = useSubmittedDocumentStore(documentId);

  if (!revision) {
    throw new Error("Revision is not defined");
  }

  return useDocumentHighlight(documentId, revision.id)();
};
